import { AppModule } from './../app.module';
import { ImgPipe } from './../img.pipe';
import { RouterModule, Routes } from '@angular/router';
import { FirebaseAuthService } from './../_guard/firebase-auth-service';
import { AdminComponent } from './admin/admin.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { AdminBannerComponent } from './admin-banner/admin-banner.component';
import { FileUploadModule } from 'primeng/fileupload';
import { ProgressBarModule } from 'primeng/progressbar';
import { GrowlModule } from 'primeng/growl';
import { EditorModule } from 'primeng/editor';
import { AdminSocialComponent } from './admin-social/admin-social.component';
import { AdminGeralComponent } from './admin-geral/admin-geral.component';
import { AdminFotosComponent } from './admin-fotos/admin-fotos.component';
import { AdminFotoscampanhaComponent } from './admin-fotoscampanha/admin-fotoscampanha.component';
import { AdminBiografiaComponent } from './admin-biografia/admin-biografia.component';
import { AdminBlogComponent } from './admin-blog/admin-blog.component';
import { AdminEventosComponent } from './admin-eventos/admin-eventos.component';
import { AdminProjetosComponent } from './admin-projetos/admin-projetos.component';
import { AdminPropostasComponent } from './admin-propostas/admin-propostas.component';
import { AdminTimelineComponent } from './admin-timeline/admin-timeline.component';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AdminBlogFormComponent } from './admin-blog-form/admin-blog-form.component';
import { CalendarModule } from 'primeng/calendar';
import { AdminEventosFormComponent } from './admin-eventos-form/admin-eventos-form.component';
import { AdminTimelineFormComponent } from './admin-timeline-form/admin-timeline-form.component';
import { AdminPesquisaComponent } from './admin-pesquisa/admin-pesquisa.component';
import { AdminPesquisaFormComponent } from './admin-pesquisa-form/admin-pesquisa-form.component';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { AccordionModule } from 'primeng/accordion';
import { AdminVideoComponent } from './admin-video/admin-video.component';

const routes: Routes = [
  { path: 'admin/geral', component: AdminGeralComponent, canActivate: [FirebaseAuthService]},
  { path: 'admin/banner', component: AdminBannerComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/social', component: AdminSocialComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/fotos', component: AdminFotosComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/fotoscampanha', component: AdminFotoscampanhaComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/biografia', component: AdminBiografiaComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/timeline', component: AdminTimelineComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/projetos', component: AdminProjetosComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/blog', component: AdminBlogComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/eventos', component: AdminEventosComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/propostas', component: AdminPropostasComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/blog/cadastrar', component: AdminBlogFormComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/blog/alterar/:id', component: AdminBlogFormComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/eventos/cadastrar', component: AdminEventosFormComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/eventos/alterar/:id', component: AdminEventosFormComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/timeline/cadastrar', component: AdminTimelineFormComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/timeline/alterar/:id', component: AdminTimelineFormComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/pesquisa/cadastrar', component: AdminPesquisaFormComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/pesquisa', component: AdminPesquisaComponent, canActivate: [FirebaseAuthService] },
  { path: 'admin/videos', component: AdminVideoComponent, canActivate: [FirebaseAuthService] }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    CommonModule,
    FileUploadModule, ProgressBarModule, GrowlModule, EditorModule,
    DialogModule, InputTextareaModule, ToggleButtonModule,
    ConfirmDialogModule, CalendarModule, AccordionModule
  ],
  exports: [AdminComponent],
  declarations: [AdminComponent, HeaderComponent, AdminBannerComponent,
    AdminSocialComponent, AdminGeralComponent, AdminFotosComponent, AdminFotoscampanhaComponent,
    AdminBiografiaComponent, AdminBlogComponent, AdminEventosComponent, AdminProjetosComponent,
    AdminPropostasComponent, AdminTimelineComponent, AdminBlogFormComponent, AdminEventosFormComponent,
    AdminTimelineFormComponent, AdminPesquisaComponent, AdminPesquisaFormComponent, AdminVideoComponent],
  providers: [ConfirmationService, MessageService]
})
export class AdminModule { }



// WEBPACK FOOTER //
// ./src/app/admin/admin.module.ts